import React from 'react';
import { Gallery } from '../components/Gallery';

interface GalleryPageProps {
  language: string;
}

export function GalleryPage({ language }: GalleryPageProps) {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1 className="page-title">
          {language === 'en' ? 'Our Gallery' : 'A Nossa Galeria'}
        </h1>
        <p className="page-description">
          {language === 'en' 
            ? 'A space crafted with heart and soul, made for those who celebrate life in every moment.'
            : 'Um espaço criado com carinho e alma, pensado para quem celebra a vida em cada momento.'}
        </p>
      </div>
      <Gallery language={language} />
    </div>
  );
}
